import { render, staticRenderFns } from "./PromotionProductsSection.vue?vue&type=template&id=4d61b949"
import script from "./PromotionProductsSection.vue?vue&type=script&lang=js"
export * from "./PromotionProductsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports